export default function EMVendorController(
  $scope,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  vmSharedModelService,
  addFunctionVendorDialog,
  addVendorProductDialog,
  emSharedModelService,
) {
  const vm = this;

  vm.canExpand = vm.vendor.functionProducts && vm.vendor.functionProducts.length > 0
    && (vm.isEdit || (vm.vendor.functionProducts.filter(p => p.isSelected === true)).length > 0);
  vm.cssPrefix = vm.isEdit ? 'dialog-' : '';

  vm.handleExpandClick = _handleExpandClick;
  vm.handleSelectionChange = _handleSelectionChange;
  vm.handleAddProduct = _handleAddProduct;
  vm.handleEditVendor = _handleEditVendor;
  vm.handleDeleteVendor = _handleDeleteVendor;
  vm.handleDeletedProduct = _handleDeletedProduct;

  activate();

  /** *****************************************
   * Event Handlers
   */

  function _handleExpandClick() {
    if (vm.canExpand || (vm.vendor.functionProducts && vm.vendor.functionProducts.length > 0)) {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleSelectionChange() {
    if (vm.canExpand) {
      vm.isExpanded = true;
    }
    if (vm.vendor.functionProducts && vm.vendor.functionProducts.length > 0) {
      vm.vendor.functionProducts = vm.vendor.functionProducts.map(
        product => ({
          ...product,
          isSelected: vm.vendor.isSelected
        })
      );
    }
  }

  function _handleEditVendor($event) {
    ssDialogService.dialogs.enterpriseModeling.addFunctionVendorDialog = ssDialogService.alert(
      addFunctionVendorDialog.getOptions($event, {
        vendor: vm.vendor,
        addCallback: null
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.addFunctionVendorDialog);
  }

  function _handleDeleteVendor($event) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteVendorDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Vendor?',
        message: `Deleting vendor might sever its existing association within BCP Blueprint,
        Vendor Management or Audit trail. Are you sure you want to delete the vendor "${vm.vendor.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteVendorDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteVendorDialog();
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return vmSharedModelService.deleteVendor(vm.vendor.vendorId)
      .then(() => {
        vm.deleteCallback(vm.vendor);
        alerts.success(`The Vendor "${vm.vendor.name}" has successfully been deleted.`);
        _closeDeleteVendorDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the vendor.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _closeDeleteVendorDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteVendorDialog);
  }

  function _handleDeletedProduct(product) {
    vm.vendor.functionProducts.splice(vm.vendor.functionProducts.indexOf(product), 1);

    // eslint-disable-next-line max-len
    if ((vm.vendor.functionProducts === undefined) || (vm.vendor.functionProducts === null) || (vm.vendor.functionProducts.length === 0)) {
      vm.canExpand = false;
    }
  }

  function _handleAddProduct($event) {
    _showEditProductDialog($event);
  }

  function _showEditProductDialog($event) {
    ssDialogService.dialogs.enterpriseModeling.editProductDialog = ssDialogService.alert(
      addVendorProductDialog.getOptions($event, {
        product: emSharedModelService.createNewProduct({ vendorId: vm.vendor.vendorId }),
        vendorId: vm.vendor.vendorId,
        addCallback: _handleAddedProduct,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editProductDialog);
  }

  function _handleAddedProduct(newProduct) {
    newProduct.isSelected = true;
    vm.vendor.isSelected = true;
    vm.vendor.functionProducts = vm.vendor.functionProducts || [];
    vm.vendor.functionProducts.push(newProduct);
    if (vm.vendor.functionProducts && vm.vendor.functionProducts.length > 1) {
      vm.vendor.functionProducts = vmSharedModelService.sortByName(vm.vendor.functionProducts);
    }
  }

  function activate() {
    $scope.$on('selectVendorProduct', (event, opt) => {
      _selectVendorProduct(opt.vendorId);
    });
  }

  function _selectVendorProduct(vendorId) {
    if (vendorId === vm.vendor.vendorId) {
      vm.vendor.isSelected = true;
    }
  }
}

EMVendorController.$inject = [
  '$scope',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'alerts',
  'vmSharedModelService',
  'addFunctionVendorDialog',
  'addVendorProductDialog',
  'emSharedModelService'
];
